import widgetData from './widgetData';

const root = {
	widgetData
};

export default root;
